import React from 'react';
import Layout from '../../components/Layout';
import NotFound from '../../components/NotFound/NotFound';
import Compare from './Compare';
import { COMPARE_PAGES } from './data';

// SEO B2.3: competitor "alternative" comparison pages at /compare/:slug.
async function action({ params, store }) {
  const siteTitle =
    (store.getState().siteSettings &&
      store.getState().siteSettings.data &&
      store.getState().siteSettings.data.siteTitle) ||
    'BestHand';

  const slug = params.slug;
  const data = COMPARE_PAGES[slug];

  if (!data) {
    return {
      title: `Page Not Found | ${siteTitle}`,
      status: 404,
      component: (
        <Layout>
          <NotFound title={'Page Not Found'} />
        </Layout>
      ),
    };
  }

  return {
    title: data.title,
    description: data.metaDescription,
    component: (
      <Layout>
        <Compare slug={slug} data={data} />
      </Layout>
    ),
  };
}

export default action;
